import { AxiosError } from 'axios';
import { types, flow, Instance } from 'mobx-state-tree';
import { authClient } from 'utils/axios.config';
import { withAlertStore } from 'components/Core/CustomAlert/store';
import { ErrorData, StatusTypeReq, IResponse, ICountryCodeData } from 'types/common';
import { IAdminUser, IAdminUserForm, IEditAdminUser } from './types';
import { filterPOSTData } from 'utils/prepareData';

const { model, frozen, maybeNull } = types;

export const UsersStore = model('UsersStore', {
  adminUsers: maybeNull(frozen<IAdminUser[]>()),
  curAdminUser: maybeNull(frozen<IAdminUser>()),
  usersCountryCodes: maybeNull(frozen<ICountryCodeData[]>()),
})
  .extend(withAlertStore)
  // .views((self) => ({}))
  .actions((self) => ({
    setUsersCountryCodes(data: ICountryCodeData[] | null) {
      self.usersCountryCodes = data;
    },
    setAdminUsers(users: IAdminUser[] | null) {
      self.adminUsers = users;
    },
    setCurAdminUser(user: IAdminUser | null) {
      self.curAdminUser = user;
    },
  }))
  .actions((self) => ({
    errorHandling({ response }: AxiosError<IResponse<ErrorData>>) {
      const msg = response?.data.message || 'Internal server error';
      self.alertStore.showAlert(msg);
      throw new Error(msg);
    },
  }))
  // ADMIN USERS API SECTION
  .actions((self) => ({
    getUsersCountryCodes: flow(function* () {
      yield authClient
        .get('admin-users/country-codes')
        .then(({ data: { data } }) => self.setUsersCountryCodes(data))
        .catch(self.errorHandling);
    }),
    getAdminUsersData: flow(function* () {
      yield authClient
        .get('admin-users')
        .then(({ data: { data } }) => self.setAdminUsers(data))
        .catch(self.errorHandling);
    }),
    changeAdminUserStatus: flow(function* ({ id, status }: StatusTypeReq) {
      yield authClient
        .patch(`admin-users/status/${id}`, { status })
        // .then(() => {
        //   self.setAdminUsers(self.adminUsers?.map((item) => (item.id === id ? { ...item, status } : item)) || []);
        // })
        .catch(self.errorHandling);
      return id;
    }),
    addAdminUser: flow(function* (data: IAdminUserForm) {
      yield authClient
        .post(`admin-users`, data)
        .then(({ data: { data } }) => self.setAdminUsers((self.adminUsers || []).concat(data)))
        .catch(self.errorHandling);
    }),
    editAdminUser: flow(function* (data: IEditAdminUser) {
      yield authClient
        .patch(`admin-users/${data.id}`, filterPOSTData(data))
        .then(({ data: { data } }) =>
          self.setAdminUsers(self.adminUsers?.map((item) => (item.id === data.id ? data : item)) || [])
        )
        .catch(self.errorHandling);
    }),
  }));

export type IUsersStore = Instance<typeof UsersStore>;
